import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Table } from 'antd'
import React from 'react'

import { AmountCol, getDisplayValue } from '../../helpers'
import { PayrollIcon } from '../../PayrollIcon'

export function AutomaticPayItems({ detail }) {
  const { formatCurrency } = useFormatter()
  const formattedUnit = formatCurrency(null, true)
  return (
    <div className='p-4' style={{ flex: 5 }} span={10}>
      <Horizontal verticalCenter className='mb-4'>
        <Texto appearance='medium' category='heading-small' className='flex-1'>
          AUTOMATIC PAY
        </Texto>
        <Texto category='h4' appearance='success' weight='bold'>
          {formattedUnit} {addCommasToNumber(detail?.automatic_total, 2)}
        </Texto>
      </Horizontal>
      <Table
        className='payroll-calculated-table'
        columns={automaticColumns()}
        dataSource={detail?.automatic}
        pagination={false}
      />
    </div>
  )
}

const automaticColumns = () => {
  const { formatVolume, formatDistance } = useFormatter()
  const formattedVolume = formatVolume(null, false)
  const formattedDistance = formatDistance(null, false)
  return [
    {
      title: 'INCOME RULE',
      dataIndex: 'name',
      key: 'name',
      render: (value, row) => {
        const showVolume = row.grouping === 'Gallons'
        const showDistance = row.grouping === 'Miles'
        return (
          <Horizontal verticalCenter>
            <PayrollIcon name={row.grouping} />
            <b className='ml-2'>
              {showVolume && formattedVolume}
              {showDistance && formattedDistance}
              {!showVolume && !showDistance && row.grouping}
            </b>
          </Horizontal>
        )
      },
    },
    {
      title: 'Quantity',
      dataIndex: 'units',
      key: 'units',
      align: 'right',
      render: (value, row) => {
        const display = row.override_units || row.override_units === 0 ? row.override_units : row.units
        return <b>{getDisplayValue(display)}</b>
      },
    },
    {
      title: 'AMOUNT',
      dataIndex: 'dollar',
      key: 'dollar',
      align: 'right',
      render: (value, row) => {
        return <AmountCol showPopover row={row} />
      },
    },
  ]
}
